import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { theme } from "theme";
import React from "react";
import { Box, Stack } from "@chakra-ui/layout";
import slugify from "slugify";
import { SmoothScrollLink } from "components/atoms/SmoothScroll";

interface ITableOfContentProps {
  children: any;
  href: string;
}

const TableOfContentLink = ({ children, href }: ITableOfContentProps) => {
  return (
    <Box>
      <SmoothScrollLink to={href} offset={2000}>
        <Box
          cursor="pointer"
          color="gray.600"
          _hover={{
            color: "primary.600",
            borderColor: "primary.500",
          }}
        >
          {children}
        </Box>
      </SmoothScrollLink>
    </Box>
  );
};

export const LegalArticleTableOfContents = ({ article }) => {
  const headingTypes = [BLOCKS.HEADING_2, BLOCKS.HEADING_3];

  const headings = article.content.filter((item) =>
    headingTypes.includes(item.nodeType)
  );

  const document: any = {
    nodeType: "document",
    content: headings,
  };

  const options = {
    renderNode: {
      [BLOCKS.HEADING_2]: (node, children) => {
        const href = slugify(node.content[0].value, {
          lower: true,
        });

        return <TableOfContentLink href={href}>{children}</TableOfContentLink>;
      },
      [BLOCKS.HEADING_3]: (node, children) => {
        const href = slugify(node.content[0].value, {
          lower: true,
        });
        return (
          <Box pl={5}>
            <TableOfContentLink href={href}>{children}</TableOfContentLink>
          </Box>
        );
      },
    },
  };

  return (
    <>
      <Box
        w={{ base: "100%", lg: 300 }}
        position="sticky"
        top={20}
        p={10}
        right={0}
        pl={{ lg: 0 }}
        fontSize="sm"
      >
        {document.content.length > 0 && (
          <>
            <Box
              mb={3}
              fontWeight={600}
              textTransform="uppercase"
              fontSize="xs"
              color="gray.700"
              letterSpacing="wide"
            >
              Contents
            </Box>
            <Stack spacing={3}>
              {documentToReactComponents(document, options)}
            </Stack>
          </>
        )}
      </Box>
    </>
  );
};
